import { render, staticRenderFns } from "./AuthorizerList.vue?vue&type=template&id=0a3348f6&scoped=true&"
import script from "./AuthorizerList.vue?vue&type=script&lang=js&"
export * from "./AuthorizerList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizerList.vue?vue&type=style&index=0&id=0a3348f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3348f6",
  null
  
)

export default component.exports